export const businessEndpoints = {
  GET_BUSINESSES: '/businesses/',
  GET_BUSINESS: '/businesses/:businessId',
  CREATE_BUSINESS: '/businesses/create/',
  UPDATE_BUSINESS: '/businesses/:businessId/update/',
  BUSINESS_ATTRIBUTES: '/business-attributes/',
}
